import { render, staticRenderFns } from "./facturacion.vue?vue&type=template&id=1666b5eb&"
import script from "./facturacion.vue?vue&type=script&lang=js&"
export * from "./facturacion.vue?vue&type=script&lang=js&"
import style0 from "./facturacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports